const parseVersion = (value) => {
  if (value === null || value === undefined) return null;
  const str = String(value).trim();
  if (!str) return null;
  const parts = str.split(".").map((p) => Number(p));
  if (parts.some((n) => Number.isNaN(n))) return null;
  return parts;
};

export const semverGte = (a, b) => {
  const left = parseVersion(a);
  const right = parseVersion(b);

  if (left && right) {
    const len = Math.max(left.length, right.length);
    for (let i = 0; i < len; i += 1) {
      const l = left[i] ?? 0;
      const r = right[i] ?? 0;
      if (l > r) return true;
      if (l < r) return false;
    }
    return true;
  }

  return String(a ?? "") === String(b ?? "");
};

export const isConsentExpired = (expiresAt) => {
  if (expiresAt === null || expiresAt === undefined) return false;
  const time = new Date(expiresAt).getTime();
  if (Number.isNaN(time)) return true;
  return time <= Date.now();
};

export const computeIsConsentValid = (payload) => {
  if (!payload || typeof payload !== "object") return false;
  if (payload.hasValidConsent !== true) return false;
  if (!payload.acceptedVersion) return false;
  if (!semverGte(payload.acceptedVersion, payload.currentVersion)) return false;
  if (isConsentExpired(payload.expiresAt)) return false;
  return true;
};
